import { render, staticRenderFns } from "./LicenseDialog.vue?vue&type=template&id=4bb071d0"
import script from "./LicenseDialog.vue?vue&type=script&lang=ts"
export * from "./LicenseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports